module.exports = __webpack_public_path__ + "static/media/cctv-systems.88f05acd.webp";